module.exports = __webpack_public_path__ + "media/images/partners/5_dostupne_kino-dcaa1c558e66b187c4d36ee2066685db.png";